import React from 'react';

import * as styles from './styles/styles.module.scss';

export default function RadioFilter({ config, handler }) {
  const renderOptions = options => {
    const result = Object.entries(options).map(([key, option]) => {
      return (
        <div key={key} name={key} onClick={handler(key)} className={`${styles.button} ${option.selected ? styles.active : ''}`}>
          {option.name}
        </div>
      );
    });
    return result;
  };

  return (
    <div>
      <div className={styles.group}>{renderOptions(config)}</div>
    </div>
  );
}
